<script>
	import { onMount } from 'svelte';
	import mapbox from 'mapbox-gl';
	import BusMarkers from './BusMarkers.svelte';

	export let lat;
	export let lon;
	export let zoom;

	let container;
	let map;

	let busLineMenuOpen = false;
	function openBusLineMenu() {
		busLineMenuOpen = true;
	}

	function closeBusLineMenu() {
		busLineMenuOpen = false;
	}

	class HelloWorldControl {
		onAdd(map) {
			this._map = map;
			this._container = document.createElement('div');
			this._container.classList.add('mapboxgl-ctrl', 'mapboxgl-ctrl-group');
			let button = document.createElement('button');
			button.className = "mapboxgl-ctrl-icon";
			button.innerText = "#";
			button.style.cssText = "font-size: 1.6em; font-weight: bold;";
			button.onclick = openBusLineMenu;
			this._container.appendChild(button);
			return this._container;
		}

		onRemove() {
			this._container.parentNode.removeChild(this._container);
			this._map = undefined;
		}
	}

	onMount(() => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = '/mapbox-gl.css';

		link.onload = () => {
			map = new mapbox.Map({
                container,
                style: 'https://api.maptiler.com/maps/basic/style.json?key=irZ3X7LCdZbB6oIIyuBv',
                center: [lon, lat],
                zoom
            });
            
            map.addControl(new mapbox.NavigationControl(), 'top-left');
            
            map.addControl(new mapbox.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
			}), 'top-left');
			
			map.addControl(new HelloWorldControl(), 'top-right');
		};

		document.head.appendChild(link);

		return () => {
			map.remove();
			link.parentNode.removeChild(link);
		};
	});
</script>

<style>
	.map {
		width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        z-index: 0;
    }
</style>

<div class="map" bind:this={container}></div>
<BusMarkers {map} {busLineMenuOpen} on:closeBusLineMenu={closeBusLineMenu}></BusMarkers>